import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-06-12'
        tag='Kidizen'
        title="Selling on Kidizen: A Beginner's Guide"
      >
        <p>
          If you're a parent with kids in school, you've probably heard of Kidizen. If not, then let me introduce it to
          you! Kidizen is an online marketplace for parents and their children. Many items are available on the site
          that caters to mothers and their children's needs - from clothes and toys to backpacks and art supplies.{' '}
        </p>
        <p>
          Have you ever wondered how to sell in Kidizen? If you are looking forward to selling some clothes that your
          children have outgrown or have some toys that your kid no longer wants, then selling them on Kidizen is a
          great way to earn some cash and de-clutter at the same time. Many aspects of selling on this site make it hard
          for new sellers to keep track of all the rules and get started. Luckily for you, we have created a guide with
          everything you need to know about selling on Kidizen!{' '}
        </p>
        <p>
          This guide will familiarize you with what items can and cannot be sold on the site, how much it costs to sell
          in Kidizen, and some helpful tips to get you started!{' '}
        </p>

        <h3>What is Kidizen? </h3>
        <p>
          Kidizen is a social media app built for moms where they can earn money and find the latest styles for their
          kids. It was first introduced in 2013 as "Itizen," and the name was changed to "Kidizen" in 2014 when the
          company decided to launch its iOS app.{' '}
        </p>
        <p>
          Since then, Kidizen has been a popular buying and selling marketplace for gently used kid's fashion and
          essentials. In 2019 they introduced the Mama category, allowing users to buy and sell women's types and
          accessories. Now, Kidizen caters to over 800,000 registered users and offers various categories such as toys,
          women's clothing, books, and other kid-friendly products.{' '}
        </p>

        <h3>Items You Can and Can't Sell on Kidizen. </h3>
        <p>The following are the items you can and can't list on Kidizen: </p>
        <p>
          Sellers can list all items labeled for kids that fall under the correct categories and subcategories provided
          by Kidizen. Examples are toys, kids' clothing, children's books, and other kid-friendly products.{' '}
        </p>
        <p>
          In comparison, the following items are the prohibited items you cannot list on Kidizen under the kid's
          category. This includes but is not limited to:
        </p>
        <ul>
          <li>Replicas </li>
          <li>Food products </li>
          <li>Electronic items and accessories (i.e., Tablets, phone accessories) </li>
          <li>Home decor</li>
          <li>Kitchen products </li>
          <li>Illegal items</li>
          <li>Hazardous products </li>
        </ul>
        <p>
          Aside from selling kid-labeled and kid-friendly products, sellers can also list women's fashion under the mama
          category as long as they fall under the correct categories and subcategories. Examples of items you can sell
          under this category are maternity clothes, Women's clothes, shoes, and other women's accessories.{' '}
        </p>
        <p>
          Meanwhile, the following items are the prohibited items you cannot list on Kidizen under the mama category.
          This includes but is not limited to:
        </p>
        <ul>
          <li>Counterfeited products </li>
          <li>Perfume/Fragrances</li>
          <li>Wellness products </li>
          <li>Beauty products (i.e., make-ups) </li>
          <li>Hygiene products (i.e., soap, shampoo)</li>
          <li>Tech products (i.e, gadgets/ phone accessories</li>
          <li>Home decor</li>
          <li>Kitchen products </li>
          <li>Any illegal substances</li>
          <li>Hazardous Items</li>
        </ul>
        <p>
          Any sellers who will be found to repeatedly list or try to sell any of the aforementioned prohibited items
          will be penalized, including the permanent suspension of their Kidizen account.{' '}
        </p>

        <h3>How to List items</h3>
        <p>
          Listing an item on Kidizen is fast and easy. Simply follow the step-by-step process to create your listing.{' '}
        </p>
        <ol>
          <li>Log in to your Kidizen account, then click "Sell" from the bottom navigation </li>
          <li>Fill in the listing title</li>
          <li>Upload clear photos of the items</li>
          <li>Select the correct category and subcategory of your item. </li>
          <li>Add the gender and size</li>
          <li>Fill in the brand and condition of the item (i.e., NWT/ Very good used condition) </li>
          <li>Write a detailed and honest product description</li>
          <li>Select your estimated shipping cost and pricing </li>
          <li>Review the information you've provided</li>
          <li>
            Click <strong>Submit</strong> to publish your listing and start selling!{' '}
          </li>
        </ol>
        <p>Here are some valuable tips you may consider when creating a listing on Kidizen: </p>
        <ul>
          <li>
            <p>
              <strong>Upload clear and detailed images</strong> - For starters, having at least three clear pictures of
              the item is important in creating a listing. Add the front, back, size tags, brand or specific details,
              and blemishes (stains, small holes.) Be sure to upload photos of the flaws so the buyers know what to
              expect when purchasing the item. Remember, the more images you provide on your listing, the better. This
              will lessen questions from potential buyers.
            </p>
          </li>
          <li>
            <p>
              <strong>Check your items carefully and disclose any imperfections</strong> - Be thorough in checking the
              condition of your item. Check the front, back, and sides at least 2-3x, and disclose any flaws your item
              may have. In your product description, you may also include the reason behind the category your item's
              condition falls into to set your buyer's expectations.{' '}
            </p>
            <p>You may choose your item's condition from the following category: </p>
            <ul>
              <li>
                New with Tags (NWT) - Items with tags attached from the original retailer. Item has never been used/worn
                and has no defects.{' '}
              </li>
              <li>
                New without Tags (NWOT) - These are items from the original retailer, but the tags have already been
                removed. Items have never been used, worn, altered, or washed and have no defects. Handmade items are
                also included in this category.{' '}
              </li>
              <li>
                Excellent Used Condition (EUC) - These are like-new items that have been lightly used or worn but do not
                show any signs of wear and tear.{' '}
              </li>
              <li>
                Very Good Used Condition (VGUC) - These items have light signs of wear and tear, including color fading,
                minor scuffs, or writings on clothing or textiles.{' '}
              </li>
              <li>
                Good Used Condition (GUC) - These items have moderate signs of wear and tear that must be disclosed in
                the product description, such as color fading, minor stains, missing closures, etc.{' '}
              </li>
              <li>
                Play Condition - These are heavily used or worn items and show visible defects that must be disclosed in
                the item's description. This includes color fade, heavy pilling, holes, tears, shrinkage, missing or
                broken closures (zipper, buttons), and other apparent signs of defects.{' '}
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>Notice a new flaw? Edit your listing.</strong> You may edit your published listing if you see a
              new defect and want to upload it and write it down on the item's description. Doing so creates customer
              trust and drives repeat purchases. To edit your previously published listing, click the listing in your
              profile, then click the Edit button.{' '}
            </p>
          </li>
        </ul>

        <h3>Kidizen Selling Fees</h3>
        <p>
          Kidizen offers simple and straightforward fees for all its sellers. The app keeps the 12% +0.50 marketplace
          fee on each item you sell on the platform. For example, on a $15 order, Kidizen gets to maintain a 12% + 0.50
          marketplace fee, which equates to $2.3, yielding $12.7 for the seller.
        </p>

        <h3>How Kidizen Sellers Get Paid</h3>
        <p>
          In order to get paid, you must ship the items within seven days from the date of purchase. Sellers have to
          purchase a shipping label or enter a valid tracking number (if you are sending via a different courier.)
          Kidizen requires that you buy a Kidizen-provided shipping label or enter any valid tracking number to release
          your earnings.{' '}
        </p>
        <p>
          Tracking must be entered and scanned within seven days from the buyer's purchase date, or the buyer can
          request a refund. Once you shipped the order and have been scanned in by USPS, your earnings (total sales
          minus marketplace fee) will be moved from <strong>Pending Kid Bucks</strong> to{' '}
          <strong>Redeemable Kid Bucks</strong>.{' '}
        </p>
        <p>
          The reason behind the delays in crediting your income is to make sure the seller can issue a refund once they
          fail to ship the item within seven days. You may check your pending balance by clicking <strong>Me</strong>{' '}
          &gt; Settings &gt; Kid Bucks.{' '}
        </p>
        <p>
          There are two ways to use your redeemable kid bucks. You can either use it to make a purchase on Kidizen or
          have it withdrawn using PayPal or a bank account. Just go to your profile &gt; Settings &gt; Kid Bucks &gt;
          Redeemable Balance. For new Kidizen sellers, you have to wait for 72 hours from when you create your account
          before you can cash out or withdraw any of your redeemable bucks.{' '}
        </p>

        <h3>Sell More with OneShop</h3>
        <p>
          While selling children's clothing on Kidizen helps you reach a more targeted audience, utilizing other
          strategies to connect with more buyers across multiple platforms is the key to achieving our selling goals
          quickly.{' '}
        </p>
        <p>
          Whether online selling is a full-time job or a side hustle, the ultimate goal is to reach sales goals, boost
          shop exposure, and eventually grow your reselling venture. Using a reliable automation service helps you
          achieve all these without doing more work.{' '}
        </p>
        <p>
          OneShop is a trusted automation service that acts as your 24/7 virtual assistant who does all the boring and
          tedious work for you. It allows you to seamlessly cross-list across multiple platforms, giving you a higher
          chance of closing deals even outside Kidizen. OneShop automatically de-lists too once you sell, so you no
          longer have to worry about selling a single item to multiple buyers.{' '}
        </p>
        <p>
          OneShop also made it simple to manage your reselling business through the additional helpful features it
          offers. From setting your goals, tracking sales, ordering shipping supplies, scheduling package pickups, and
          finding an Item's Registration Number, OneShop got you covered!{' '}
        </p>
        <p>
          Make OneShop part of your business and experience how it makes your life easier by giving you more time to do
          other important work that helps in growing your reselling venture.{' '}
          <a href='https://tools.oneshop.com/signup'>Sign-up now</a>, set up your account in less than three minutes,
          and enjoy a 7-day free trial!
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
